import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import Wallpaper from '../../../domain/entities/Wallpaper';

export default function reducer(
  state: {[key: number]: Wallpaper} = {},
  action: AnyAction,
): {[key: number]: Wallpaper} {
  switch (action.type) {
    case Types.IndexWallpapersSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Wallpaper}, record: Wallpaper) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    default:
      return state;
  }
}
